import * as types from '../types';
import { prepend } from '../utils';
import Storage from 'Shared/helpers/storageManager';
import _ from 'lodash';
import { createNamespacedHelpers } from 'vuex';

const onboardingStorage = Storage.researcherOnboarding.getObject();

export const defaultState = {
  invitation: _.get(window, 'pageParams.invitation', null),
  jobTitle: onboardingStorage.jobTitle || '',
  organization: onboardingStorage.organization || {},
  source: onboardingStorage.source || '',
  referralCode: _.get(window, 'pageParams.referralCode', null),
  user: {},
};

export const namespace = 'researcherSignup';
export const helpers = createNamespacedHelpers(namespace);
export const prependNamespace = prepend(namespace);

export const mutations = {
  [types.SET_FIELDS](state, fields) {
    Storage.researcherOnboarding.merge(_.omit(fields, ['user']));
    _.merge(state, fields);
  },
};

export const getters = {
  // returning a function allows us to avoid caching (these should be evaluated fresh)
  [types.SIGNUP_COMPLETE]: (state) => () => {
    return !_.isEmpty(state.user.id)
  },
  [types.ORG_COMPLETE]: (state) => () =>
    !_.isEmpty(state.user.organizations) || !_.isEmpty(state.organization),
  [types.PERSONAL_FORM_COMPLETE]: (state) => () =>
    !_.isEmpty(state.jobTitle) && !_.isEmpty(state.source),
};

export default {
  namespaced: true,
  state: { ...defaultState },
  mutations,
  getters,
};
